import { fetchDataById, updateEntity } from '../../../services/axiosInstanceService';
import { userParser } from '../usersParser';

/**
 * Fetch user with is ID
 * @param {string} userIdIri - user '@id'
 * @returns {Promise<UserRequestResponse>} promise
 * @returns {IUser} returns.user : Parsed user
 * @returns {IMarketResearch | null} returns.marketResearch : Parsed user market research
 */
async function fetchUserById(userIdIri: string): Promise<UserParsedResponse> {
  try {
    if (!userIdIri) throw new Error('UserIdIri not found');

    const result = await fetchDataById(userIdIri);

    const parsed = userParser({ data: result }) as UserParsedResponse;

    return parsed;
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Fetch user market research data
 * @param {string} userIdIri - user '@id'
 * @returns {Promise<IMarketResearch>} promise
 * @returns {IMarketResearch} returns : Parsed user market research
 */
async function fetchUserMarketResearch(userIdIri: string): Promise<IMarketResearch> {
  try {
    if (!userIdIri) throw new Error('UserIdIri not found');

    const result = await fetchDataById(`${userIdIri}/market-research`);

    // Parse market research data
    const marketResearch: IMarketResearch = {
      idIri: result['@id'],
      totalAds: result.total_ads,
      totalNewAds: result.total_ads_today,
      cities: null,
    };

    return marketResearch;
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Update user
 * @param {string} userIdIri - user '@id'
 * @param {UpdateUserParams} body - updated user values
 * @param {string?} companyIdIri - company '@id'
 * @returns {Promise<UserRequestResponse>} promise
 * @returns {IUser} returns.user : Parsed user
 * @returns {IMarketResearch | null} returns.marketResearch : Parsed user market research
 */
async function updateUser(
  idIri: string | null,
  body: UpdateUserParams,
): Promise<IUser> {
  try {
    if (!idIri) throw new Error('No user idIri found');

    const result = await updateEntity({ idIri, body });
    const parsed = userParser({
      data: result,
    }) as UserParsedResponse;

    return parsed.user;
  } catch (error) {
    return Promise.reject(error);
  }
}

export { fetchUserById, fetchUserMarketResearch, updateUser };
